import React from "react";
import { PhoneIcon, MapPinIcon } from "@heroicons/react/24/solid";

import whiteLogo from "../../assets/Logo/whitelogo.svg";
import whatsappIcon from "../../assets/icons/Footer/Group (8).svg";
import emailIcon from "../../assets/icons/Footer/Group 1271.svg";
import instagramIcon from "../../assets/icons/Footer/Group 268.svg";

export default function Footer() {
  return (
    <footer className="flex flex-col">
      <div className="bg-[#674DA2] flex items-center gap-4 md:gap-16 px-8 lg:px-52 md:px-24 py-10">
        <div>
          <img src={whiteLogo} alt="logo" className="w-5/6 h-5/6" />
        </div>
        <div className="flex flex-col gap-6 w-full ">
          <div className="w-full h-px bg-white" />
          <div className="flex flex-col md:flex-row lg:flex gap-y-4 md:gap-1 items-start md:items-center justify-between text-white">
            <div className="flex items-center gap-3">
              <PhoneIcon className="h-6 w-6" />
              <span className="text-md">+7 (777) 665-59-65</span>
            </div>
            <div className="flex items-center gap-3">
              <MapPinIcon className="h-6 w-6" />
              <span className="text-md">Астана қ. Қошқарбаева 11/2</span>
            </div>
            <div className="flex items-center gap-3">
              {/* <img src={emailIcon} alt="emailIcon" className="w-6 h-6" /> */}
              <a
                href="https://www.instagram.com/ustazkids"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={instagramIcon}
                  alt="Instagram"
                  className="w-6 h-6 cursor-pointer"
                />
              </a>

              <a
                href="https://api.whatsapp.com/send/?phone=%2B77776655965&text&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={whatsappIcon}
                  alt="WhatsApp"
                  className="w-6 h-6 cursor-pointer"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#4D377F] py-3 flex text-white text-xs px-8 lg:px-52 md:px-24 justify-end">
        <span>Құпиялылық саясаты</span>
      </div>
    </footer>
  );
}
